<admin-app-header></admin-app-header>

<div class="container-fluid">
    <div class="row header">
        <div class="col-12">
            <h2 class="mb-3"><i class="fa-solid fa-user-plus me-2"></i>Leads (Archived)</h2>
            <p class="text-muted">Historical lead data from the "Parking Not Found" form - this functionality has been integrated into the Parker CRM</p>
        </div>
    </div>

    <div class="row">
        <div class="col-12">
            <div class="card">
                <div class="card-body">
                    <div *ngIf="loading" class="text-center py-5">
                        <div class="spinner-border text-primary" role="status">
                            <span class="visually-hidden">Loading...</span>
                        </div>
                        <p class="mt-2 text-muted">Loading leads...</p>
                    </div>

                    <div *ngIf="!loading && leads.length === 0" class="text-center py-5">
                        <i class="fa-solid fa-inbox fa-3x text-muted mb-3"></i>
                        <p class="text-muted">No leads found</p>
                    </div>

                    <div *ngIf="!loading && leads.length > 0" class="table-responsive">
                        <table class="table table-striped table-hover">
                            <thead>
                                <tr>
                                    <th>Date</th>
                                    <th>Name</th>
                                    <th>Email</th>
                                    <th>Phone</th>
                                    <th>Company</th>
                                    <th>City</th>
                                    <th>Ideal Address</th>
                                    <th>Bays</th>
                                    <th>Duration</th>
                                    <th>Reason</th>
                                    <th>Comments</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let lead of leads">
                                    <td class="text-nowrap">{{ formatDate(lead.createdAt) }}</td>
                                    <td>{{ lead.name }} {{ lead.surname }}</td>
                                    <td>
                                        <a *ngIf="lead.email" [href]="'mailto:' + lead.email">{{ lead.email }}</a>
                                        <span *ngIf="!lead.email">-</span>
                                    </td>
                                    <td>
                                        <a *ngIf="lead.phoneNumber" [href]="'tel:' + lead.phoneNumber">{{ lead.phoneNumber }}</a>
                                        <span *ngIf="!lead.phoneNumber">-</span>
                                    </td>
                                    <td>{{ lead.company || '-' }}</td>
                                    <td>{{ lead.city || '-' }}</td>
                                    <td>{{ lead.idealAddress || '-' }}</td>
                                    <td>{{ lead.baysRequired || '-' }}</td>
                                    <td>{{ lead.durationInMonths ? lead.durationInMonths + ' months' : '-' }}</td>
                                    <td class="reason-cell">{{ getReasonLabel(lead.reasonForNotFinding) }}</td>
                                    <td class="comments-cell">{{ lead.additionalComments || '-' }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <div *ngIf="!loading" class="mt-3 text-muted small">Total: {{ leads.length }} leads</div>
                </div>
            </div>
        </div>
    </div>
</div>
